// extracted by mini-css-extract-plugin
export default {"Box":"column-drop-zone-sash-module__Box--ueDjN","Box_1":"column-drop-zone-sash-module__Box_1--IiAV0"};